import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Paper, Typography, Tabs, Tab, Alert, Button, Link as MuiLink } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import BusinessIcon from '@mui/icons-material/Business';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IndividualRegistrationForm from './IndividualRegistrationForm';
import EnterpriseRegistrationForm from './EnterpriseRegistrationForm';

/**
 * Página de registro com escolha entre cliente Individual (PF) e Empresarial (PJ)
 */
export default function RegisterPage() {
  const navigate = useNavigate();
  const [clientType, setClientType] = useState(0); // 0 = individual, 1 = enterprise
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  // Função para lidar com a mudança de tipo de cliente
  const handleTabChange = (event, newValue) => {
    setClientType(newValue);
  };

  // Função para lidar com o registro bem-sucedido
  const handleRegistrationSuccess = (message) => {
    setSuccessMessage(message);
    setErrorMessage('');
    // Redirecionar para a página de login após 3 segundos
    setTimeout(() => {
      navigate('/login');
    }, 3000);
  };

  // Função para lidar com erros de registro
  const handleRegistrationError = (error) => {
    setSuccessMessage('');
    setErrorMessage(
      error.message || 'Ocorreu um erro durante o registro. Por favor, tente novamente.',
    );
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#f5f5f5',
        p: 2,
      }}
    >
      <Paper elevation={3} sx={{ width: '100%', maxWidth: 800, p: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <Button startIcon={<ArrowBackIcon />} onClick={() => navigate('/login')} sx={{ mr: 2 }}>
            Voltar
          </Button>
          <Typography variant="h5" component="h1">
            Crie sua conta
          </Typography>
        </Box>

        {successMessage && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {successMessage}
          </Alert>
        )}

        {errorMessage && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {errorMessage}
          </Alert>
        )}

        <Tabs
          value={clientType}
          onChange={handleTabChange}
          variant="fullWidth"
          aria-label="Tipo de cliente para registro"
          sx={{ mb: 4 }}
        >
          <Tab icon={<PersonIcon />} label="Pessoa Física" id="individual-tab" />
          <Tab icon={<BusinessIcon />} label="Pessoa Jurídica" id="enterprise-tab" />
        </Tabs>

        <Box role="tabpanel" hidden={clientType !== 0} id="individual-panel">
          {clientType === 0 && (
            <IndividualRegistrationForm
              onSuccess={handleRegistrationSuccess}
              onError={handleRegistrationError}
            />
          )}
        </Box>

        <Box role="tabpanel" hidden={clientType !== 1} id="enterprise-panel">
          {clientType === 1 && (
            <EnterpriseRegistrationForm
              onSuccess={handleRegistrationSuccess}
              onError={handleRegistrationError}
            />
          )}
        </Box>

        <Box sx={{ mt: 3, textAlign: 'center' }}>
          <Typography variant="body2">
            Já possui uma conta?{' '}
            <MuiLink component="button" variant="body2" onClick={() => navigate('/login')}>
              Faça login
            </MuiLink>
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
}
